"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trial = require("@/api/trial.js");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _viewMixin = _interopRequireDefault(require("@/views/trial/components/mixins/viewMixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_viewMixin.default],
  components: {
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      req: {
        reqPage: _trial.disciplinePage,
        reqInsert: _trial.disciplineInsert,
        reqUpdate: _trial.disciplineUpdate,
        reqDelete: _trial.disciplineDelete
      },
      title: "庭审纪律",
      tableHeaderColor: this.$tableHeaderColor,
      stateArr: [{
        //状态数组
        value: "1",
        label: "已启用"
      }, {
        value: "0",
        label: "已禁用"
      }],
      titlevalue: "",
      statevalue: "",
      //状态值
      fileList: [],
      form: {
        title: "",
        content: "",
        state: ""
      },
      formRules: {
        title: [{
          required: true,
          message: "请输入标题名"
        }],
        content: [{
          required: true,
          message: "请输入内容"
        }],
        state: [{
          required: true,
          message: "请选择"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var page,
          data,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              data = {};
              if (this.statevalue != "") {
                data["state"] = this.statevalue;
              }
              if (this.titlevalue != "") {
                data["title"] = this.titlevalue;
              }
              _context.next = 6;
              return this.getList(page, data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    clearAllConditon: function clearAllConditon() {
      this.statevalue = "";
      this.titlevalue = "";
      this.getData(1);
    } // handlePreview() {},
    // handleRemove() {},
    // handleChange(file) {
    //   console.log(file);
    // }
  },
  mounted: function mounted() {
    this.getData(1);
  }
};
exports.default = _default;